import { create } from 'store';

export const useSelectedCustomerIds = create<{
  selectedCustomerIds: string[];
  setSelectedCustomerIds: (type: string[]) => void;
}>()((set) => ({
  selectedCustomerIds: [],
  setSelectedCustomerIds: (newCustomers) => set({ selectedCustomerIds: newCustomers }),
}));
